<template>
  <div class="modeList" @click="detail">
    <div class="modeList-title">
      {{ item.studentname ? item.studentname : "-" }}-{{
        item.studentnb ? item.studentnb : "-"
      }}
    </div>
    <ul>
      <li class="modeList-item">
        <span>异动类别:</span>
        <p>{{ item.ydlb ? item.ydlb : "-" }}</p>
      </li>
      <li class="modeList-item">
        <span>原班级:</span>
        <p>{{ item.oldbj ? item.oldbj : "-" }}</p>
      </li>
      <li class="modeList-item">
        <span>现班级:</span>
        <p>{{ item.newbj ? item.newbj : "-" }}</p>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "modeList",
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {};
  },
  created() {},
  methods: {
    detail() {
      this.$emit("detail", this.item);
    }
  }
};
</script>

<style lang="less" scoped>
.modeList {
  position: relative;
  background: #ffffff;
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 10px;
  .modeList-title {
    width: calc(~"100% - 70px");
    font-family: SourceHanSansCN-Medium;
    font-size: 16px;
    line-height: 22px;
    color: #333333;
    letter-spacing: 0;
    font-weight: bolder;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-bottom: 4px;
  }
  .modeList-item {
    display: flex;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #999999;
    letter-spacing: 0;
    font-weight: 400;
    line-height: 20px;
    span {
      white-space: nowrap;
    }
    p {
      white-space: wrap;
      margin-left: 5px;
    }
    & + .modeList-item {
      margin-top: 2px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/teacher/xjydsh/mode/modeList.vue